<template>
  <div>
    <v-layout row wrap justify-center align-center>
      <v-flex xs12 md9 lg6>
        <v-img src="@/assets/forgiveness-main-pic.png">
          <v-layout v-if="screener" row fill-height align-end>
            <v-flex xs12>
              <v-layout v-if="!isConsumerPurchased(screener.id)" row wrap justify-center align-center >
                <v-flex class="cursour_pointer" xs8 md8 lg7>
                  <v-img @click.stop="$emit('onBuyTicket',screener)" src="@/assets/forgiveness-watch-btn.png"></v-img>
                </v-flex>
              </v-layout>
               <v-layout v-else-if="isConsumerEnrolled(screener.id)" row wrap justify-center align-center >
                <v-flex class="cursour_pointer" xs8 md8 lg7>
                  <v-img @click.stop="$emit('onWatch',screener)" src="@/assets/forgiveness-watch-btn.png"></v-img>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap justify-center align-center>
                <v-flex  class="cursour_pointer" xs8 md8 lg7>
                  <v-img @click="showTrailerpreview({ film: screener.films[0] })" src="@/assets/forgiveness-trailer-btn.png"></v-img>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-img>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center align-center>
      <v-flex xs12 md9 lg6>
         <v-layout row wrap align-end  justify-end>
          <v-flex xs6>
              <v-layout row wrap justify-center align-center>
                    <v-flex  xs7 md7 lg7 class="cursour_pointer pa-2 pt-3">
                      <a href="https://www.netflix.com/title/80244547
" target="_blank" rel="noopener noreferrer"><v-img  src="@/assets/forgiveness-previous-film.png"></v-img></a>

                    </v-flex>
                  </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- Trailer popup -->
    <v-dialog
      max-width="80vmin"
      v-if="showPreview"
      v-model="showPreview"
      persistent
    >
      <v-card>
        <v-card-title>
          <div class="title primary--text">
            {{ $t("screener.trailer.preview.title") }}
          </div>
          <v-spacer></v-spacer>
          <v-btn
            small
            dark
            icon
            color="primary"
            @click="hideTrailerpreview"
            class="mx-0"
          >
            <v-icon small>$vuetify.icons.rms_close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <EmbedPlayer
            v-if="film.trailer"
            v-bind:value="film.trailer"
            video_type="video/youtube"
          ></EmbedPlayer>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EmbedPlayer from "@/components/player/EmbedPlayer.vue";
export default {
  name: "ForgivenessOverview",
  props: {
    screener: {
      type: Object,
      default: null
    }
  },
  components: {
    EmbedPlayer
  },
  computed: {
    ...mapGetters("consumer", {
      isConsumerEnrolled: "isEnrolled",
      isConsumerPurchased: "isPurchased"
    }),
  },
  data() {
    return {
      showPreview: false,
      film: null,
    }
  },
  methods: {
    showTrailerpreview(event) {
      this.showPreview = true;
      this.film = event.film;
    },
    hideTrailerpreview() {
      this.showPreview = false;
      this.film = null;
    },
  }
};
</script>
<style scoped>
.forgiveness-background {
  background: url("../../assets/forgiveness-main-pic.png") no-repeat center
    center fixed !important;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  margin: 0;
  padding: 0;
  background-repeat: no-repeat;
  background-position: center center;
}

.outer {
  width: 40%;
  max-width: 500px;
  max-height: 500px;
  margin: 2.5%;
  float: left;
}

.inner {
  width: 100%;
  padding-top: 100%;

  background-image: url(http://placehold.it/500x500);
  background-repeat: no-repeat;
  background-position: center center;

  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.cursour_pointer {
  cursor: pointer;
}
</style>
